module.exports = __webpack_public_path__ + "static/bird-feature-2dd1788e485b12f9293fd5c78e4808f8.png";